<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Подписка на рассылку') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">
        <v-row>
          <v-col>
            <v-checkbox
                v-model="mailing.lotPublication"
                v-test="{ checkbox: 'lotPublication' }"
                :label="$t('Публикация торговой процедуры')" />
            <v-checkbox
                v-model="mailing.failedBid"
                v-test="{ checkbox: 'failedBid' }"
                :label="$t('Торги не состоялись')" />
            <v-checkbox
                v-model="mailing.lotEditing"
                v-test="{ checkbox: 'lotEditing' }"
                :label="$t('Редактирование торговой процедуры')" />
            <v-checkbox
                v-model="mailing.globalMailing"
                v-test="{ checkbox: 'globalMailing' }"
                :label="$t('Общая рассылка')" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="continueOperation">
          {{ $t('Сохранить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import GeneralError from './GeneralError.vue'
  export default {
    components: {
      GeneralError
    },
    props: {
      subscriptions: {
        lotPublication: false,
        failedBid: false,
        lotEditing: false,
        globalMailing: false
      },
      dialogProp: {
        type: Object,
        default: () => {
          return {
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        isLoading: false,
        mailing: {
          lotPublication: false,
          failedBid: false,
          lotEditing: false,
          globalMailing: false
        }
      }
    },
    watch: {
      subscriptions: {
        immediate: true,
        deep: true,
        handler: function (newValue) {
          for (const key in this.mailing) {
            this.mailing[key] = newValue[key] || false
          }
        }
      }
    },
    methods: {
      continueOperation: async function () {
        try {
          if (this.dialogProp.callback) {
            this.isLoading = true
            await this.dialogProp.callback(this.mailing)
            this.isLoading = false
          }
          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
